import Api from 'utils/Api'

class FinancesService {

    getImgOfReceipt(receipt_html) {
        return Api.call('/transference/transference-receipt', 'post', { receipt_html })
            .then(res => res)
            .catch(err => { throw err })
    }

    getMoipBalances() {
        return Api.call('/transference/moip-balance', 'get')
            .then(res => res.data)
            .catch(err => { throw err })
    }

    transferAvailableMoipBalance(amount_to_transfer, amount_to_transfer_formatted, base_64_receipt) {
        return Api.call('/transference/transfer-available-moip-balance', 'post', { amount_to_transfer, amount_to_transfer_formatted, base_64_receipt })
            .then(res => res.data)
            .catch(err => { throw err })
    }

    getExtractByMonth() {
        return Api.call('/extract/extract-entry', 'get')
            .then(res => res.data)
            .catch(err => { throw err })
    }

    getExtractOfMonth(params) {
        return Api.call('/transference/get-extract-by-month', 'get', params)
            .then(res => res.data)
            .catch(err => { throw err })
    }

    getTransferences() {
        return Api.call('/transference/get-transferences-by-company', 'get')
            .then(res => res.data)
            .catch(err => { throw err })
    }

    getCompanyPayments() {
        return Api.call('/payment/get-company-payments', 'get')
            .then(res => res.data)
            .catch(err => { throw err })
    }

    getPaymentModalInfo(params) {
        return Api.call('payment/get-payment-modal-info', 'get', params)
            .then(res => res.data)
            .catch(err => { throw err })
    }

}

export default new FinancesService();


// WEBPACK FOOTER //
// ./src/services/FinancesService.js